// Canned messages for Admin > Users > Send Email to Users (StuiEmailModal `templates` prop).
// User Notification is the free-form one and the default, so it comes first.
//
// `subject` is the part after the locked "DAWN Notice: " / "DAWN Notice (GF): " prefix, in
// title case, with no colon of its own (the prefix already ends in one). Anything in [square
// brackets] is a slot: a field's slot is replaced live with what is picked (and put back if the
// pick is cleared); any other slot is text the sender must rewrite. The popup blocks Send while
// any slot is left.
//
// Fields: 'datetime' (StuiDateTime; minuteStep is its arrow step, defaultNow starts it at now
// rounded down to that step plus any defaultOffsetMinutes, timeIfToday drops the date when it is
// today, and subjectDateOnly puts just the date in the subject) and 'select' (an option's label
// goes in the subject, its text in the body). Times are written with the sender's time zone,
// because recipients span several.
//
// `tone` colours the email's subject panel: info (teal, default), warning (amber), danger (red),
// success (green), blue. The server accepts only those names.
//
// `revisions: true` shows Admin > Users' rev log button beside the subject, which fills [Version]
// and the [Highlight] bullet from the rev log.

export const BROADCAST_EMAIL_TEMPLATES = [
  {
    key: 'notification',
    name: 'User Notification',
    tone: 'info',
    subject: '[Topic]',
    fields: [],
    bodyHtml:
      '<p>Hello,</p>' +
      '<p>[Message]</p>' +
      '<p>Thank you,<br>The DAWN team</p>',
  },
  {
    key: 'maintenance',
    name: 'Scheduled Maintenance',
    tone: 'warning',
    subject: 'Scheduled Maintenance - [Start]',
    fields: [
      { key: 'start', label: 'Start', type: 'datetime', slot: '[Start]', minuteStep: 15, defaultNow: true, subjectDateOnly: true },
      { key: 'end', label: 'End', type: 'datetime', slot: '[End]', minuteStep: 15, defaultNow: true, defaultOffsetMinutes: 60 },
    ],
    bodyHtml:
      '<p>DAWN will be unavailable for scheduled maintenance from <strong>[Start]</strong> to <strong>[End]</strong>.</p>' +
      '<p>Please save your work before then. No action is needed afterward.</p>',
  },
  {
    key: 'outage',
    name: 'Service Outage',
    tone: 'danger',
    subject: 'Service Outage - [Status]',
    fields: [
      {
        key: 'status', label: 'Status', type: 'select', slot: '[Status]',
        options: [
          { value: 'unavailable', label: 'Unavailable', text: 'unavailable' },
          { value: 'slow', label: 'Slow', text: 'running slowly' },
          { value: 'erroring', label: 'Erroring', text: 'returning errors' },
        ],
      },
      { key: 'asOf', label: 'As of', type: 'datetime', slot: '[As Of]', defaultNow: true, timeIfToday: true, minuteStep: 5 },
    ],
    bodyHtml:
      '<p>We are aware that DAWN is <strong>[Status]</strong> as of [As Of].</p>' +
      '<p>We are working on it and will send an update when it is resolved. There is no need to report it.</p>',
  },
  {
    key: 'restored',
    name: 'Service Restored',
    tone: 'success',
    subject: 'Service Restored',
    fields: [
      { key: 'reportedAt', label: 'Issue reported at', type: 'datetime', slot: '[Reported At]', defaultNow: true, timeIfToday: true, minuteStep: 5 },
    ],
    bodyHtml:
      '<p>The issue reported at [Reported At] is resolved and DAWN is available again.</p>' +
      '<p>If something still looks wrong, use Help, then Email Support.</p>',
  },
  {
    key: 'release',
    name: 'Release / New Feature',
    tone: 'blue',
    subject: "What's New in [Version]",
    fields: [],
    revisions: true,
    bodyHtml:
      '<p>DAWN has been updated. Highlights:</p>' +
      '<ul><li>[Highlight]</li></ul>' +
      '<p>The DAWN development team is continuously making corrections and enhancements. If you see ' +
      'something that needs to be corrected or think of a new feature, please submit a bug report or ' +
      'a help request through DAWN.</p>',
  },
];
